import { useEffect } from 'react'

import Helmet from 'react-helmet'

import { ClientError } from '@tribeplatform/gql-client'
import { useAuthToken, useMember } from '@tribeplatform/react-sdk/hooks'
import { SlateRenderer } from '@tribeplatform/slate-kit/components'

import { useAnalytics } from '../../hooks/useAnalytics'
import sampleMemberSlate from '../../samples/member-slate.json'
import { isNotFound } from '../../utils/error'
import { NotFound } from '../Error/NotFound'

type MemberPageProps = {
  id: string
}

export const MemberPage = ({ id }: MemberPageProps) => {
  const {
    error,
    data: { network },
  } = useAuthToken()
  const { data: member } = useMember({
    id,
    fields: {
      authMemberProps: 'all',
      banner: 'all',
      profilePicture: 'all',
      role: 'basic',
      fields: 'all',
      score: 'all',
    },
    useQueryOptions: {
      refetchOnMount: 'always',
      retry: false,
    },
  })

  const title = `${member?.name} - ${network?.name}`

  const analytics = useAnalytics()
  useEffect(() => {
    analytics.trackPageView(title)
  }, [title])

  if (!member) {
    if (isNotFound(error as ClientError)) return <NotFound />
    return null
  }

  return (
    <>
      <Helmet>
        <link
          rel="alternate"
          type="application/rss+xml"
          title={member?.name}
          href={`https://${network?.domain}/rss/member/${member?.id}/posts`}
        />
      </Helmet>
      <SlateRenderer slate={sampleMemberSlate} additionalContext={{ member }} />
    </>
  )
}
